<template>
    <div class="container">
        <div class="col-start-3 col-span-8 flex justify-center items-center flex-wrap text-center text-green-dark gap-5 mb-20 md:mb-11 xl:mb-16 2xl:mb-20 2xl:space-x-20">
            <div>
                <span class="label label--transparent">Filter<span class="hidden md:inline-block">:</span></span>
            </div>
            <button v-show="currentCategory !== null" @click="setCategory()" class="label label--transparent">All</button>
            <button v-for="cat in categoriesList"
                    :key="`category-${cat.cat_ID}`"
                    @click="setCategory(cat.cat_ID)"
                    :class="{
                        'opacity-50': currentCategory === cat.cat_ID
                    }"
            >
                <label-theme :category="cat"/>
            </button>
        </div>


        <div class="grid grid-cols-1 grid-gap gap-y-7 md:grid-cols-3 md:gap-y-5 lg:gap-y-8 xl:gap-y-10 2xl:gap-y-20">
            <BoxPost v-for="post in printPosts" :key="`post-${post.id}`" :post='post' class="fade"></BoxPost>
        </div>

        <button
            v-show="currentPostsPerPage < currentPosts.length"
            @click="loadMore"
            class="
                    w-full block text-2xl rounded-3xl font-light tracking-[0.02em] py-5 mt-7 bg-white
                    md:py-0 md:mx-auto md:bg-transparent md:text-sm md:mt-16
                    xl:text-xl xl:mt-20
            ">
            Load More
        </button>
    </div>
</template>

<script>
import BoxPost from "./partials/box-post.vue";
import LabelTheme from "./partials/label-theme.vue";

export default {
    name: "blog-posts",
    components: {LabelTheme, BoxPost},
    props: ['categories', 'posts'],
    data() {
        return {
            categoriesList: JSON.parse(this.categories),
            postsList: JSON.parse(this.posts),
            currentPosts: [],
            postsPerPage: 6,
            currentPostsPerPage: 6,
            currentCategory: null,
        }
    },
    computed: {
        printPosts() {
            return this.currentPosts.slice(0, this.currentPostsPerPage);
        },
    },
    mounted() {
        this.filterPosts();
    },
    methods: {
        loadMore() {
            this.currentPostsPerPage += this.postsPerPage;
        },
        filterPosts() {
            let posts = this.postsList;
            
            posts = posts.filter(post => {
                if ( this.currentCategory !== null ) {
                    return this.currentCategory === post.category.cat_ID;
                }
                else {
                    return post;
                }
            })
            
            this.currentPosts = posts;
        },
        setCategory(id = null) {
            this.currentCategory = id;
            this.filterPosts();
        },
    },
}
</script>

<style scoped lang="scss">
    .fade {
        animation: fade-up .6s ease both;
    
        @keyframes fade-up {
            from {
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        }
    }
</style>